<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <rkm-row v-if="transferenciaLaboratorio">

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Laboratório"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="laboratorios"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="laboratorio.unidadeId"
                                    :disabled="model.unidadeDisabled"
                                    value-field="unidadeId"
                                    @change="resetLaboratorio"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturasLaboratorio"
                                    :validations="validations.infraestrutura"
                                    textField="nome"
                                    v-model="laboratorio.infraestruturaId"
                                    :disabled="!laboratorio.unidadeId || model.unidadeDisabled"
                                    valueField="id"
                                    show-default-option
                                    @change="resetLaboratorio"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Unidade origem"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="unidades"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="unidade.unidadeId"
                                    :disabled="!laboratorio.unidadeId && transferenciaLaboratorio || model.unidadeDisabled"
                                    value-field="unidadeId"
                                    @change="handleBlur"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturas"
                                    :validations="validations.infraestrutura"
                                    textField="nome"
                                    v-model="unidade.infraestruturaId"
                                    :disabled="!unidade.unidadeId || model.unidadeDisabled"
                                    valueField="id"
                                    show-default-option
                                    @change="resetUnidadeOrigem"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="flex-nowrap" v-if="!unidadeSolicitanteLaboratorio">
                            <rkm-col class="flex-grow-1">
                                <rkm-form-select
                                    :options="data.form.tipo"
                                    label="Tipo"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="unidade.cotaTipoId"
                                    value-field="id"
                                    :validations="validations.tipo"
                                    :disabled="!unidade.infraestruturaId"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Início"
                                    v-model="unidade.inicio"
                                    :validations="validations.inicio"
                                    :disabled="!unidade.cotaTipoId"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Fim"
                                    v-model="unidade.fim"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col
                    v-if="unidadeSolicitanteLaboratorio"
                    cols="12"
                >
                    <rkm-area
                        title="Cota"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    label="Tipo"
                                    v-model="cota.tipoNome"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    label="Cota"
                                    v-model="cota.cota"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="7">
                                <rkm-form-date-picker
                                    label="Período"
                                    v-model="cota.periodo"
                                    range
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>

                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col
                    cols="12"
                    v-if="!hideUnidadeSolicitante"
                >

                    <Form
                        ref="Form"
                        :data="data"
                        :transferenciaLaboratorio="transferenciaLaboratorio"
                        :cotaUnidadeSolicitante="cotaUnidadeSolicitante"
                        :exames="exames"
                        :origem="unidade"
                        :laboratorio="laboratorio"
                        :unidadeDisabled="unidade.fim ? true : false"
                        :unidades="unidades"
                        :UnidadeSolicitanteOrigem="unidadeSolicitanteOrigem"
                        :cotasLaboratorio="cotasLaboratorio"
                        :cotaOrigem="cotaOrigem"
                        :examesOrigem="examesOrigem"
                        @resetForm="resetForm"
                        @handleAlter="handleAlter"
                        @save="save"
                    />

                </rkm-col>
            </rkm-row>
        </rkm-form>

    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Components.
import Form from './components/Form'

// Moment.
import moment from 'moment'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    components: { Form },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        unidades(){

            const unidadesOrigem = []

            if (this.transferenciaLaboratorio) {

                if (this.cotasLaboratorio.length > 0) {

                        this.cotasLaboratorio.map(cota => {

                            if (cota.unidadeSolicitante.length > 0) {

                                cota.unidadeSolicitante.map(infraestrutura => {

                                    let principal = this.data.form.unidades.find(u => u.id ===
                                        infraestrutura.unidadeSolicitanteId).infraestruturas.find(u => u.id
                                            === infraestrutura.infraestruturaSolicitanteId).principal

                                    const unidadeInseridaOrigem = unidadesOrigem.find(u => u.unidadeId
                                        === infraestrutura.unidadeSolicitanteId)

                                    if (unidadeInseridaOrigem) {

                                        let verifyUnidade = unidadeInseridaOrigem.infraestruturas.find(u => u.id ===
                                            infraestrutura.infraestruturaSolicitanteId)

                                        if (!verifyUnidade) {

                                            unidadeInseridaOrigem.infraestruturas.push({

                                                id: infraestrutura.infraestruturaSolicitanteId,
                                                nome: infraestrutura.infraestruturaNome,
                                                principal: principal,
                                            })
                                        }

                                    } else {

                                        unidadesOrigem.push({

                                            unidadeId: infraestrutura.unidadeSolicitanteId,
                                            nomeFantasia: infraestrutura.unidadeSolicitante,
                                            infraestruturas: [
                                                {
                                                    id: infraestrutura.infraestruturaSolicitanteId,
                                                    nome: infraestrutura.infraestruturaNome,
                                                    principal: principal,
                                                }
                                            ]
                                        })
                                    }
                                })
                            }

                            if (cota.exames.length > 0) {

                                cota.exames.forEach(exames => {

                                    exames.unidadeSolicitante.map(infraestrutura => {

                                        let principal = this.data.form.unidades.find(u => u.id ===
                                            infraestrutura.unidadeSolicitanteId).infraestruturas.find(u => u.id
                                                === infraestrutura.infraestruturaSolicitanteId).principal

                                        const unidadeInseridaOrigem = unidadesOrigem.find(u => u.unidadeId
                                            === infraestrutura.unidadeSolicitanteId)

                                        if (unidadeInseridaOrigem) {

                                            let verifyUnidade = unidadeInseridaOrigem.infraestruturas.find(u => u.id ===
                                                infraestrutura.infraestruturaSolicitanteId)

                                            if (!verifyUnidade) {

                                                unidadeInseridaOrigem.infraestruturas.push({

                                                    id: infraestrutura.infraestruturaSolicitanteId,
                                                    nome: infraestrutura.infraestruturaNome,
                                                    principal: principal,
                                                })
                                            }

                                        } else {

                                            unidadesOrigem.push({

                                                unidadeId: infraestrutura.unidadeSolicitanteId,
                                                nomeFantasia: infraestrutura.unidadeSolicitante,
                                                infraestruturas: [
                                                    {
                                                        id: infraestrutura.infraestruturaSolicitanteId,
                                                        nome: infraestrutura.infraestruturaNome,
                                                        principal: principal,
                                                    }
                                                ]
                                            })
                                        }
                                    })
                                })
                            }
                    })
                }

            } else {

                this.data.model.cotasUnidadeSolicitante.map(infraestrutura => {

                    let principal = this.data.form.unidades.find(u => u.id ===
                        infraestrutura.unidadeId).infraestruturas.find(u => u.id
                            === infraestrutura.infraestruturaId).principal

                    const unidadeInseridaOrigem = unidadesOrigem.find(u => u.unidadeId
                        === infraestrutura.unidadeId)

                    if (unidadeInseridaOrigem) {

                        let verifyUnidade = unidadeInseridaOrigem.infraestruturas.find(u => u.id ===
                            infraestrutura.infraestruturaId)

                        if (!verifyUnidade) {

                            unidadeInseridaOrigem.infraestruturas.push({

                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            })
                        }

                    } else {

                        unidadesOrigem.push({

                            unidadeId: infraestrutura.unidadeId,
                            nomeFantasia: infraestrutura.nomeFantasia,
                            infraestruturas: [
                                {
                                    id: infraestrutura.infraestruturaId,
                                    nome: infraestrutura.infraestruturaNome,
                                    principal: principal,
                                }
                            ]
                        })
                    }
                })
            }

            this.getUnidadeOrigem(unidadesOrigem)

            return unidadesOrigem
        },
        infraestruturas() {

            if (this.unidade.unidadeId) {

                let infraestruturaPrincipal = this.unidadeSolicitanteOrigem.find(u => u.unidadeId ===
                    this.unidade.unidadeId)

                    if (infraestruturaPrincipal) {

                        if (!this.model.unidadeDisabled) {

                            this.getPrincipal(infraestruturaPrincipal.infraestruturas)
                        }

                        return infraestruturaPrincipal.infraestruturas
                    }
            }

            return []
        },
        laboratorios() {

            const unidades = []

            this.data.model.cotasLaboratorio.map(item => {

                this.data.model.unidades.filter(u => u.infraestruturaId === item.infraestruturaId).map(unidade => {

                    const unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId)

                    if (unidadeInserida) {

                        unidadeInserida.infraestruturas.push({

                            id: unidade.infraestruturaId,
                            nome: unidade.infraestruturaNome,
                            principal: unidade.infraestruturaPrincipal,
                        })

                    } else {

                        unidades.push({

                            unidadeId: unidade.unidadeId,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturas: [
                                {
                                    id: unidade.infraestruturaId,
                                    nome: unidade.infraestruturaNome,
                                    principal: unidade.infraestruturaPrincipal,
                                }
                            ]
                        })
                    }

                })

            })

            this.getUnidade(unidades)

            return unidades
        },
        infraestruturasLaboratorio() {

            if (this.laboratorio.unidadeId) {

                let infraestruturaPrincipal = this.laboratorioParametrizado.find(u => u.unidadeId === this.laboratorio.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipalLaboratorio(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            index: null,
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaId: null,
            cotaUnidadeSolicitante: false,
            exames: [],
        },
        exames: [],
        enums: {
            tipoUnidade,
            tipoCota
        },
        unidade: {
            id: null,
            cotaId: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaTipoNome: null,
            cotaValor: 0,
            cotaQuantidade: null,
            saldo: '',
            inicio: null,
            fim: null,
        },
        unidadeDestino: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaValor: '',
            cotaQuantidade: '',
            inicio: null,
            fim: null,
        },
        laboratorio: {
            unidadeId: null,
            infraestruturaId: null,
        },
        cota: {
            cota: null,
            tipoId: null,
            tipoNome: '',
            periodo: {
                start: null,
                end: null
            },
        },
        cotaUnidadeSolicitante: [],
        checkCotaLaboratorio: false,
        hideUnidadeSolicitante: false,
        newIndex: null,
        unidadeTipoId: null,
        cotaOrigem: false,
        examesOrigem: false,
        cotasLaboratorio: [],
        unidadeSolicitanteOrigem: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.cotasTransferencia.findIndex((obj =>
                    obj.laboratorioUnidadeId == this.item.laboratorioUnidadeId
                    && obj.laboratorioInfraestruturaId == this.item.laboratorioInfraestruturaId
                    && obj.origemUnidadeId == this.item.origemUnidadeId
                    && obj.origemInfraestruturaId == this.item.origemInfraestruturaId
                ));

                this.newIndex = objId

                const data = this.data.model.cotasTransferencia[objId]

                this.model.unidadeDisabled = true
                this.laboratorio.unidadeId = this.item.laboratorioUnidadeId
                this.laboratorio.infraestruturaId = this.item.laboratorioInfraestruturaId
                this.unidade.unidadeId = this.item.origemUnidadeId
                this.unidade.infraestruturaId = this.item.origemInfraestruturaId
                this.cotaUnidadeSolicitante = data.destino
                this.unidade.id = data.id

                if (this.unidadeSolicitanteLaboratorio) {

                    let cotasLaboratorio = this.cotasLaboratorio.find((obj =>
                        obj.unidadeId == this.item.origemUnidadeId
                        && obj.infraestruturaId == this.item.origemInfraestruturaId
                    ));

                    let cotaLaboratorio = cotasLaboratorio.cotaLaboratorio.find((obj =>
                        obj.id == this.itemCota.cotaId
                    ));

                    this.cota.cota = this.itemCota.cota,
                    this.cota.tipoId = cotaLaboratorio.cotaTipoId,
                    this.cota.tipoNome = cotaLaboratorio.cotaTipoNome,

                    this.cota.periodo.start = moment(
                        cotaLaboratorio.periodo.start,
                        'DD/MM/YYYY'
                    ).toDate()

                    this.cota.periodo.end = moment(
                        cotaLaboratorio.periodo.end,
                        'DD/MM/YYYY'
                    ).toDate()
                }
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (!this.unidade.id) {
                            this.unidade.id = this.uniqueId('transferencia' + new Date().getTime())
                        }

                        let laboratorioNomeFantasia = ''
                        let laboratorioInfraestruturaNome = ''

                        if (this.transferenciaLaboratorio) {

                            const laboratorio = this.data.form.unidades.find(u => u.id === this.laboratorio.unidadeId)
                            const laboratorioInfraestrutura = laboratorio.infraestruturas.find(u => u.id === this.laboratorio.infraestruturaId)

                            laboratorioNomeFantasia = laboratorio.nomeFantasia
                            laboratorioInfraestruturaNome = laboratorioInfraestrutura.nome

                           this.unidadeTipoId = this.enums.tipoUnidade.LABORATORIO

                        } else {

                            this.unidadeTipoId = this.enums.tipoUnidade.UNIDADE_SOLICITANTE
                        }

                        const unidade = this.data.form.unidades.find(u => u.id === this.unidade.unidadeId)
                        const infraestrutura = unidade.infraestruturas.find(u => u.id === this.unidade.infraestruturaId)

                        const param = {
                            id: this.unidade.id,
                            unidadeTipoId: this.unidadeTipoId,
                            laboratorioUnidadeId: this.laboratorio.unidadeId,
                            laboratorioInfraestruturaId: this.laboratorio.infraestruturaId,
                            laboratorioNomeFantasia: laboratorioNomeFantasia,
                            laboratorioInfraestrutura: laboratorioInfraestruturaNome,
                            origemUnidadeId: this.unidade.unidadeId,
                            origemInfraestruturaId: this.unidade.infraestruturaId,
                            origemNomeFantasia: unidade.nomeFantasia,
                            origemInfraestrutura: infraestrutura.nome,
                            destino: this.cotaUnidadeSolicitante,
                        }

                        if (this.newIndex !== null) {

                            const objIndex = this.data.model.cotasTransferencia.findIndex((obj => obj.id == this.model.id));

                            this.$set(this.data.model.cotasTransferencia, objIndex, this.clone(param))
                        }
                        else {

                            this.data.model.cotasTransferencia.push(this.clone(param))
                            this.newIndex = this.data.model.cotasTransferencia.findIndex((obj => obj.id == this.model.id))
                        }

                        this.$emit('save', this.clone(param))

                        this.model.unidadeDisabled = true
                        this.resetUnidadeOrigem()
                })
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasTransferencia.find(unidade =>
                unidade.id !== this.unidade.id
                && unidade.origemUnidadeId == this.unidade.unidadeId
                && unidade.origemInfraestruturaId == this.unidade.infraestruturaId
                && unidade.laboratorioUnidadeId == this.laboratorio.infraestruturaId
                && unidade.laboratorioInfraestruturaId == this.laboratorio.infraestruturaId
            )
        },
        getPrincipal(infraestruturaPrincipal) {

            this.unidade.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        getPrincipalLaboratorio(infraestruturaPrincipal) {

            this.laboratorio.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        handleAlter(item) {

            this.model.exames = item.exames

            this.unidade.cotaTipoId = item.origemCotaTipoId

            this.unidadeDestino.cotaQuantidade = item.destinoCotaQuantidade
            this.unidadeDestino.cotaValor = item.destinoCotaValor

            this.unidade.inicio= moment(
                item.origemInicio,
                'DD/MM/YYYY'
            ).toDate()

            this.checkHandleAlter = true

            this.$emit('handleAlter', true)
        },
        handleBlur() {

            if (!this.unidade.unidadeId) {

                this.unidade.infraestruturaId = null
                this.unidadeDestino.unidadeId = null
                this.unidadeDestino.infraestruturaId = null

                this.resetUnidadeOrigem()
            }
        },
        resetLaboratorio() {

                if (!this.model.unidadeDisabled) {

                    if (!this.laboratorio.unidadeId) {

                        this.laboratorio.infraestruturaId = null
                    }

                    this.unidade.unidadeId = null
                    this.unidade.infraestruturaId = null
                }

                this.resetUnidadeOrigem()
        },
        resetUnidadeOrigem() {

            this.unidade.id = null
            this.unidade.cotaId = null
            this.unidade.cotaTipoId = null
            this.unidade.unidadeTipoId = null
            this.unidade.cotaQuantidade = null
            this.unidadeDestino.cotaQuantidade = null
            this.unidade.inicio = null
            this.unidade.fim = null
            this.unidade.cotaValor = null

            this.exames = this.exames.filter(function (item) {
                item.transferido = null
                item.cotaQuantidadeTransferido = null
                item.cotaValorTransferido = null
            })

            this.model.exames = []
        },
        resetForm() {

            if (!this.model.unidadeDisabled) {

                this.laboratorio.unidadeId = null
                this.laboratorio.infraestruturaId = null
            }

            this.resetLaboratorio()
        },
        getTransferido() {

            let cotaTranferido = 0

            this.cotaUnidadeSolicitante.filter(field => field.origemCotaTipoId == this.unidade.cotaTipoId
                && moment(
                    this.getFormatedDate(this.unidade.inicio, 'YYYY-MM-DD')
                )
                .isBetween(
                    field.origemInicio.split("/").reverse().join("-"),
                    field.origemFim.split("/").reverse().join("-"),
                    null,
                    '[]'
                )

                ||  field.origemCotaTipoId == this.unidade.cotaTipoId
                    && moment(
                        this.getFormatedDate(this.unidade.fim, 'YYYY-MM-DD')
                    )
                    .isBetween(
                        field.origemInicio.split("/").reverse().join("-"),
                        field.origemFim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
            )
            .map(item => {

                if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                    cotaTranferido = cotaTranferido + this.formatSumMoney(item.destinoCotaValor)

                } else {

                    cotaTranferido = Number(cotaTranferido) + Number(item.destinoCotaQuantidade);
                }
            })

            return cotaTranferido
        },
        getRecebido() {

            let cotaRecebido = 0

            let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO
                && field.laboratorioUnidadeId == this.laboratorio.unidadeId
                && field.laboratorioInfraestruturaId ==  this.laboratorio.infraestruturaId
                )

            if (transferenciaLaboratorio.length > 0) {

                transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                Object.keys(transferenciaLaboratorio).forEach(a => {

                    let recebidos = transferenciaLaboratorio[a]
                        .filter(i => i.destinoUnidadeId == this.unidade.unidadeId
                            && i.destinoInfraestruturaId == this.unidade.infraestruturaId
                            && i.origemCotaTipoId == this.unidade.cotaTipoId
                            && moment(
                                this.getFormatedDate(this.unidade.inicio, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                i.destinoInicio.split("/").reverse().join("-"),
                                i.destinoFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                            || i.destinoUnidadeId == this.unidadeId
                                && i.destinoInfraestruturaId == this.infraestruturaId
                                && i.origemCotaTipoId == this.unidade.cotaTipoId
                                && moment(
                                    this.getFormatedDate(this.unidade.fim, 'YYYY-MM-DD')
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )
                        )

                    recebidos.forEach(v => {

                        if (v.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                            cotaRecebido = cotaRecebido + this.formatSumMoney(v.destinoCotaValor)
                        } else {

                            cotaRecebido = Number(cotaRecebido) + Number(v.destinoCotaQuantidade);
                        }
                    });
                })
            }

            return cotaRecebido
        },
        getUnidade(unidades) {
            this.laboratorioParametrizado = unidades
        },
        getUnidadeOrigem(unidades) {
            this.unidadeSolicitanteOrigem = unidades
        },
        getCotaLaboratorioTransferencia() {

            this.setLoading()

            this.repositories.parametrizacao.getCotaLaboratorioTransferencia({
                infraestrutura_id: this.laboratorio.infraestruturaId,
            })
                .then(response => {

                    this.cotasLaboratorio = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            },
    },
    mixins: [repository, object, data, formats],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
        itemCota: { type: Object, default: null },
        transferenciaLaboratorio: { type: Boolean, default: false },
        unidadeSolicitanteLaboratorio: { type: Boolean, default: false },
    },
    watch: {
        'laboratorio.infraestruturaId': function (laboratorio) {

            if (laboratorio) {

                this.getCotaLaboratorioTransferencia()
            }
        },
        'unidade.infraestruturaId': function () {

            if (this.hasUnidadeParametrizada()) {

                this.unidade.infraestruturaId = null

                this.showValidationNotification(
                    "Unidade e local de atendimento já parametrizados."
                )

                return
            }
        },
        'unidade.inicio': function () {

            this.unidade.fim = null

            this.cotaOrigem = false
            this.examesOrigem = false

            let cota = ''

            if (this.unidade.inicio) {

                if (this.transferenciaLaboratorio) {

                    let cotasLaboratorio = this.cotasLaboratorio.find(cota => cota.infraestruturaId == this.laboratorio.infraestruturaId)

                    if (cotasLaboratorio) {

                        cota = this.cotasLaboratorio
                            .find(field =>
                            field.infraestruturaId == this.laboratorio.infraestruturaId
                            && field.cotaTipoId == this.unidade.cotaTipoId
                            && moment(

                                this.getFormatedDate(this.unidade.inicio, 'YYYY-MM-DD'),
                            )
                            .isBetween(
                                field.periodo.start.split("/").reverse().join("-"),
                                field.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        )

                        if (cota) {

                            let cotaUnidade = ''

                            cotaUnidade = cota.unidadeSolicitante.find(cota => cota.infraestruturaSolicitanteId == this.unidade.infraestruturaId)

                            if (cotaUnidade) {

                                this.cotaOrigem = true

                                this.unidade.cotaId = cota.id

                                if (this.unidade.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                                    if (cotaUnidade.saldo !== null) {

                                        this.unidade.cotaQuantidade = (cotaUnidade.saldo - this.getTransferido()) + this.getRecebido()

                                        if (this.model.unidadeDisabled) {

                                           this.unidade.cotaQuantidade = this.unidade.cotaQuantidade +
                                                Number(this.unidadeDestino.cotaQuantidade)
                                        }

                                    } else {

                                        this.unidade.cotaQuantidade = (Number(cotaUnidade.cotaQuantidade) - this.getTransferido()) + this.getRecebido()

                                        if (this.model.unidadeDisabled) {

                                           this.unidade.cotaQuantidade = this.unidade.cotaQuantidade +
                                                Number(this.unidadeDestino.cotaQuantidade)
                                        }
                                    }

                                } else {

                                    if (cotaUnidade.saldo !== null) {

                                        let cotaValorTranferido = this.getTransferido()
                                        let cotaValorRecebido = this.getRecebido()

                                        cotaValorRecebido = this.formatMoney(cotaValorRecebido, 2)

                                            if (cotaValorTranferido) {

                                                cotaValorTranferido = this.formatMoney(cotaValorTranferido, 2)

                                                this.unidade.cotaValor = (this.formatSumMoney(cotaUnidade.saldo)
                                                    - this.formatSumMoney(cotaValorTranferido))
                                                    - this.formatSumMoney(cotaValorRecebido)

                                                this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                            } else {

                                                this.unidade.cotaValor = this.formatSumMoney(cotaUnidade.saldo)
                                                    - this.formatSumMoney(cotaValorRecebido)

                                                this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                            }

                                        if (this.unidadeDestino.cotaValor) {

                                            let cotaValorDestino = this.formatMoney(this.unidadeDestino.cotaValor, 2)
                                            let cotaValor = this.formatMoney(this.unidade.cotaValor, 2)

                                            this.unidade.cotaValor = this.formatSumMoney(cotaValor) +
                                               this.formatSumMoney(cotaValorDestino)

                                            this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                        }

                                    } else {

                                        let cotaValorTranferido = this.getTransferido()
                                        let cotaValorRecebido = this.getRecebido()

                                        cotaValorRecebido = this.formatMoney(cotaValorRecebido, 2)

                                        if (cotaValorTranferido) {

                                            cotaValorTranferido = this.formatMoney(cotaValorTranferido, 2)

                                            this.unidade.cotaValor = (this.formatSumMoney(cotaUnidade.cotaValor)
                                                - this.formatSumMoney(cotaValorTranferido))
                                                - this.formatSumMoney(cotaValorRecebido)

                                            this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                        } else {

                                            this.unidade.cotaValor = this.formatSumMoney(cotaUnidade.cotaValor)
                                                - this.formatSumMoney(cotaValorRecebido)

                                            this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                        }
                                    }
                                }
                            }

                            this.unidade.fim = moment(
                                cota.periodo.end,
                                'DD/MM/YYYY'
                            ).toDate()

                            this.exames = cota.exames

                            cota.exames.map(cota => cota.unidadeSolicitante).forEach(exame => {

                                if(!this.examesOrigem) {

                                    if (exame.find(unidadeSolicitante =>
                                        unidadeSolicitante.unidadeSolicitanteId ==
                                            this.unidade.unidadeId
                                        && unidadeSolicitante.infraestruturaSolicitanteId ==
                                            this.unidade.infraestruturaId)) {

                                        this.examesOrigem = true
                                    }
                                }
                            });

                            if (this.unidade.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                                this.exames.forEach(e => {

                                    let exame = this.model.exames.find(exame => exame.exameId == e.exameId)

                                        if (exame) {
                                            e.transferido = exame.cotaQuantidadeTransferido
                                            e.cotaQuantidadeTransferido = exame.cotaQuantidadeTransferido
                                        }
                                })
                            } else {

                                this.exames.forEach(e => {

                                    let exame = this.model.exames.find(exame => exame.exameId == e.exameId)

                                        if (exame) {

                                            e.transferido = exame.cotaValorTransferido
                                            e.cotaValorTransferido = exame.cotaValorTransferido
                                        }
                                })
                            }
                        } else {

                            this.showValidationNotification(`Nenhuma cota encontrada para a data
                                ${this.getFormatedDate(this.unidade.inicio, 'DD/MM/YYYY')}.`)
                        }
                    }

                } else {

                    let cotasUnidadeSolicitante = this.data.model.cotasUnidadeSolicitante.find(cota => cota.unidadeId == this.unidade.unidadeId
                        && cota.infraestruturaId == this.unidade.infraestruturaId)

                    if (cotasUnidadeSolicitante) {

                        cota = cotasUnidadeSolicitante.cotaUnidadeSolicitante
                            .find(field =>
                            field.cotaTipoId == this.unidade.cotaTipoId
                            && moment(

                                this.getFormatedDate(this.unidade.inicio, 'YYYY-MM-DD'),
                            )
                            .isBetween(
                                field.periodo.start.split("/").reverse().join("-"),
                                field.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                        )

                        if (cota) {

                            this.cotaOrigem = true

                            this.unidade.fim = moment(
                                cota.periodo.end,
                                'DD/MM/YYYY'
                            ).toDate()

                             this.unidade.cotaId = cota.id

                            if (this.unidade.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                                this.unidade.cotaQuantidade = (cota.saldo - this.getTransferido()) + this.getRecebido()

                                    if (this.model.unidadeDisabled) {

                                        this.unidade.cotaQuantidade = this.unidade.cotaQuantidade +
                                            Number(this.unidadeDestino.cotaQuantidade)
                                    }

                            } else {

                                let cotaValorTranferido = this.getTransferido()
                                let cotaValorRecebido = this.formatMoney(this.getRecebido(), 2)

                                if (cotaValorTranferido) {

                                    cotaValorTranferido = this.formatMoney(cotaValorTranferido, 2)

                                    this.unidade.cotaValor = (this.formatSumMoney(cota.cotaValor)
                                        - this.formatSumMoney(cotaValorTranferido))
                                        - this.formatSumMoney(cotaValorRecebido)

                                    this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                } else {

                                    this.unidade.cotaValor = this.formatSumMoney(cota.cotaValor)
                                        - this.formatSumMoney(cotaValorRecebido)

                                    this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                }

                                if (this.unidadeDestino.cotaValor) {

                                    let cotaValorDestino = this.formatMoney(this.unidadeDestino.cotaValor, 2)
                                    let cotaValor = this.formatMoney(this.unidade.cotaValor, 2)

                                    this.unidade.cotaValor = this.formatSumMoney(cotaValor) +
                                        this.formatSumMoney(cotaValorDestino)

                                    this.unidade.cotaValor = this.formatMoney(this.unidade.cotaValor, 2)
                                }
                            }
                        } else {

                            this.showValidationNotification(`Nenhuma cota encontrada para a data
                                ${this.getFormatedDate(this.unidade.inicio, 'DD/MM/YYYY')}.`)
                        }
                    } else {

                        this.showValidationNotification(`Nenhuma cota encontrada para a data
                            ${this.getFormatedDate(this.unidade.inicio, 'DD/MM/YYYY')}.`)
                    }

                }
            }
        },
    }
}
</script>